import './style.modules.scss'

import { Spacer } from '@ampcore/adel-react'
import { BackgroundColor } from '@ampcore/ampcom-contracts'
import React from 'react'

import { getBackgroundConfig } from './getBackgroundConfig'
import { TwoColumnBannerProps } from './TwoColumnBannerColumns'

// Wraps the shared Spacer/section/background chrome around whichever layout
// element (aligned grid or independent flex) the variant supplies as children.
export const TwoColumnBannerShell = ({
  props,
  children
}: {
  props: TwoColumnBannerProps
  children: React.ReactNode
}) => {
  const {
    backgroundImage,
    backgroundColor,
    textColor,
    componentSpacing,
    testId
  } = props

  const backgroundConfig = getBackgroundConfig(backgroundColor, textColor)

  const leftColumnContentHasImage = props.leftColumnContent?.includes('<img')
  const rightColumnContentHasImage = props.rightColumnContent?.includes('<img')
  const hasBothImages = leftColumnContentHasImage && rightColumnContentHasImage

  return (
    <Spacer spacing={componentSpacing}>
      <section
        className={`TwoColumnBanner ${backgroundConfig.classes}`}
        style={{
          backgroundImage: backgroundImage
            ? `url(${backgroundImage})`
            : backgroundConfig.facet
        }}
        data-testid={testId ? `${testId}-backgroundImage` : null}
      >
        <div
          className={`${
            backgroundColor == BackgroundColor.FADED_WHITE_FACET
              ? 'TwoColumnBanner-fadedFacet'
              : ''
          }`}
        >
          <div
            className={`u-paddingVert40 u-sm-paddingVert32 u-md-paddingVert32 u-sizeConstrained`}
          >
            <div
              className={`TwoColumnBanner-content${
                hasBothImages ? ' TwoColumnBanner-imagePair' : ''
              }`}
            >
              {children}
            </div>
          </div>
        </div>
      </section>
    </Spacer>
  )
}
